import {
  FETCH_PAGEBYPARENT_REQUEST,
  FETCH_PAGEBYPARENT_SUCCESS,
  FETCH_PAGEBYPARENT_ERROR,
} from '../constants';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_PAGEBYPARENT_REQUEST:
    case FETCH_PAGEBYPARENT_ERROR:
      return state;

    case FETCH_PAGEBYPARENT_SUCCESS:
      return action.payload;

    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/fetch_pagebyparent_reducer.js